module.exports = __webpack_public_path__ + "static/media/shefLogo.66316da6.jpeg";